"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreButton = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Restore_1 = __importDefault(require("@material-ui/icons/Restore"));
const grey_1 = __importDefault(require("@material-ui/core/colors/grey"));
const styles_1 = require("./styles");
const monace_1 = require("@cs125/monace");
const useStyles = makeStyles_1.default(theme => ({
    restore: {
        color: grey_1.default[500],
        fontSize: theme.spacing(2),
    },
}));
exports.RestoreButton = ({ editor, defaultValue }) => {
    const classes = useStyles();
    const buttonClasses = styles_1.buttonStyles();
    return (react_1.default.createElement(Tooltip_1.default, { title: "Restore", placement: "left", classes: { tooltipPlacementLeft: buttonClasses.tooltipPosition } },
        react_1.default.createElement("div", { className: buttonClasses.iconWrapper, onClick: () => monace_1.safeChangeValue(editor, defaultValue) },
            react_1.default.createElement(Restore_1.default, { className: classes.restore }))));
};
exports.RestoreButton.propTypes = {
    editor: prop_types_1.default.any.isRequired,
    defaultValue: prop_types_1.default.string.isRequired,
};
//# sourceMappingURL=RestoreButton.js.map